export default __webpack_public_path__ + "static/media/advantage-6.60834373.png";